import { FEATURES } from '../../../lib/config/constants.js'
import { canManageOrders } from '../../../lib/config/roles.js'

/**
 * Whether this user may reach the marketplace Order Overview.
 *
 * The single source of truth for both surfaces that gate it — the sidebar link
 * (MarketplaceSidebar) and the route redirect (Marketplace.logic) — so a user
 * can never see a link that bounces them, or be bounced off a route the sidebar
 * offered.
 *
 * DrayNow is unconditional: the overview has always been reachable there and
 * MV-3398 must not change DrayNow behaviour. On ModalView it opens only for the
 * order-managing roles (admin, imc — never carrier or driver) and only while the
 * ORDER_OVERVIEW tenant flag is on.
 *
 * Note the flag is read through the caller's `isFeatureEnabled` rather than the
 * store directly, so the sidebar's `tenant` prop and the page's store selector
 * both work, and tests can pass a stub.
 *
 * @param {Object} params
 * @param {string} [params.userRole] - Effective role (`authStore.user.role`)
 * @param {boolean} [params.isDrayNow] - Whether the host is DrayNow
 * @param {Function} [params.isFeatureEnabled] - Tenant feature predicate
 * @returns {boolean}
 */
export const canAccessOrderOverview = ({
  userRole,
  isDrayNow,
  isFeatureEnabled,
} = {}) => {
  if (isDrayNow) return true

  return (
    canManageOrders(userRole) &&
    Boolean(isFeatureEnabled?.(FEATURES.ORDER_OVERVIEW))
  )
}
